import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';

import useBehavioral, { BEHAVIORALS } from 'hooks/useBehavioral';
import { closeResourceModal } from 'store/reducers/global/global-reducer';
import { setIsResourceFullscreenOpen } from 'store/reducers/navbar-reducer';

export default function useNavigateHome() {
  const dispatch = useDispatch();
  const { push } = useHistory();
  const navHomepageOpenedBehavioralFunction = useBehavioral(BEHAVIORALS.NAV_HOMEPAGE_OPENED);

  return () => {
    navHomepageOpenedBehavioralFunction();
    dispatch(closeResourceModal({}));
    dispatch(setIsResourceFullscreenOpen(false));
    push('/');
  };
}
